"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROVIDER_DISPLAY = exports.PROVIDER = exports.RETURN_STATUS_DISPLAY = exports.RETURN_STATUS = exports.ORDER_UI_STATUS_DISPLAY = exports.ORDER_UI_STATUS = exports.ORDER_STATUS_DISPLAY = exports.ORDER_STATUS = exports.LOGISTICS_ORDER_ID_TRACKING_URL = exports.LOGISTICS_STATUS = exports.LOGISTICS_STATUS_DISPLAY = exports.CVS_ICON = exports.PAYMENT_STATUS_DISPLAY = exports.PAYMENT_STATUS = exports.INVOICE_STATUS_DISPLAY = exports.INVOICE_STATUS = exports.INVOICE_TYPE_DISPLAY = exports.INVOICE_TYPE = exports.INVOICE_DONATION_DISPLAY = exports.INVOICE_DONATION = exports.INVOICE_CARRIER_TYPE_DISPLAY = exports.INVOICE_CARRIER_TYPE = exports.INVOICE_CATEGORY_DISPLAY = exports.INVOICE_CATEGORY = exports.LOGISTICS_SUBTYPE_DISPLAY = exports.LOGISTICS_SUBTYPE = exports.LOGISTICS_TYPE_DISPLAY = exports.LOGISTICS_TYPE = exports.PAYMENT_SUBTYPE_DISPLAY = exports.PAYMENT_SUBTYPE = exports.returnConfirm = exports.returnRequest = exports.updateOfflineTx = exports.onUseDiscount = exports.onUseCoupon = exports.onSelectCVS = exports.getZip3 = exports.checkoutResume = exports.checkoutRequest = exports.editConfig = exports.clearCart = exports.removeFromCart = exports.editItemInCart = exports.addToCart = exports.calcPrice = exports.fetchCart = void 0;
var Config_1 = require("../Config");
var CartTypes_1 = require("../Types/CartTypes");
Object.defineProperty(exports, "INVOICE_TYPE", {
  enumerable: true,
  get: function get() {
    return CartTypes_1.INVOICE_TYPE;
  }
});
Object.defineProperty(exports, "INVOICE_TYPE_DISPLAY", {
  enumerable: true,
  get: function get() {
    return CartTypes_1.INVOICE_TYPE_DISPLAY;
  }
});
Object.defineProperty(exports, "INVOICE_STATUS", {
  enumerable: true,
  get: function get() {
    return CartTypes_1.INVOICE_STATUS;
  }
});
Object.defineProperty(exports, "INVOICE_STATUS_DISPLAY", {
  enumerable: true,
  get: function get() {
    return CartTypes_1.INVOICE_STATUS_DISPLAY;
  }
});
Object.defineProperty(exports, "PROVIDER", {
  enumerable: true,
  get: function get() {
    return CartTypes_1.PROVIDER;
  }
});
Object.defineProperty(exports, "PROVIDER_DISPLAY", {
  enumerable: true,
  get: function get() {
    return CartTypes_1.PROVIDER_DISPLAY;
  }
});
var ApiUtil_1 = require("../Utils/ApiUtil");
var CartUtil_1 = require("../Utils/CartUtil");
var taiwan_1 = require("../Constants/taiwan");
function fetchCart(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.initial_clear,
    initial_clear = _c === void 0 ? false : _c,
    _d = _b.initial_raise,
    initial_raise = _d === void 0 ? true : _d;
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart?initial_clear=" + initial_clear + "&initial_raise=" + initial_raise + "&token=" + Config_1.get().UserOutlet.getValue().token)];
        case 1:
          nextCart = _e.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.fetchCart = fetchCart;
function calcPrice(productId, _a) {
  var qty = _a.qty,
    variants = _a.variants,
    _b = _a.extraConfigs,
    extraConfigs = _b === void 0 ? {} : _b;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/calc", {
            method: 'post',
            data: {
              product: productId,
              config: {
                qty: qty,
                variants: variants,
                extra_data: __assign({}, extraConfigs)
              }
            }
          })];
        case 1:
          return [2 /*return*/, _c.sent()];
      }
    });
  });
}
exports.calcPrice = calcPrice;
function addToCart(productId, _a) {
  var qty = _a.qty,
    variants = _a.variants,
    _b = _a.extraConfigs,
    extraConfigs = _b === void 0 ? {} : _b;
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/add?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: {
              product: productId,
              config: {
                qty: qty,
                variants: variants,
                extra_data: __assign({}, extraConfigs)
              }
            }
          })];
        case 1:
          nextCart = _c.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.addToCart = addToCart;
function editItemInCart(index, config) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/edit?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: {
              index: index,
              config: config
            }
          })];
        case 1:
          nextCart = _a.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.editItemInCart = editItemInCart;
function removeFromCart(index) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/delete?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: {
              index: index
            }
          })];
        case 1:
          nextCart = _a.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.removeFromCart = removeFromCart;
function clearCart() {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/empty_cart?token=" + Config_1.get().UserOutlet.getValue().token)];
        case 1:
          nextCart = _a.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.clearCart = clearCart;
function editConfig(nextConfig) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/item/edit_config?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'post',
            data: nextConfig
          })];
        case 1:
          nextCart = _a.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.editConfig = editConfig;
function onUseCoupon(coupon) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/coupon/use?token=" + Config_1.get().UserOutlet.getValue().token + "&client_id=" + Config_1.get().clientId, {
            method: 'post',
            data: {
              coupon: coupon
            }
          })];
        case 1:
          nextCart = _a.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.onUseCoupon = onUseCoupon;
function onUseDiscount(discountConfig) {
  return __awaiter(this, void 0, void 0, function () {
    var nextCart;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/cart/discount/use?token=" + Config_1.get().UserOutlet.getValue().token + "&client_id=" + Config_1.get().clientId, {
            method: 'post',
            data: __assign({}, discountConfig)
          })];
        case 1:
          nextCart = _a.sent();
          CartUtil_1.mapRandomKey(nextCart);
          Config_1.get().CartOutlet.update(nextCart);
          return [2 /*return*/, nextCart];
      }
    });
  });
}
exports.onUseDiscount = onUseDiscount;
function checkoutRequest(coupon, use_full_points, points, gift_points) {
  if (use_full_points === void 0) {
    use_full_points = false;
  }
  if (points === void 0) {
    points = 0;
  }
  if (gift_points === void 0) {
    gift_points = 0;
  }
  return __awaiter(this, void 0, void 0, function () {
    var endpoints, url;
    return __generator(this, function (_a) {
      endpoints = {
        v1: Config_1.get().apiHost + "/checkout/request?token=" + Config_1.get().UserOutlet.getValue().token + "&points=" + points + "&gift_points=" + gift_points + "&use_full_points=" + (use_full_points ? 'true' : 'false'),
        v2: Config_1.get().apiHost + "/payment/checkout/request?token=" + Config_1.get().UserOutlet.getValue().token + "&points=" + points + "&gift_points=" + gift_points + "&use_full_points=" + (use_full_points ? 'true' : 'false')
      };
      url = endpoints[Config_1.get().fastelVersion];
      if (coupon) {
        url += "&coupon=" + encodeURIComponent(coupon);
      }
      ApiUtil_1.redirect(url);
      return [2 /*return*/];
    });
  });
}

exports.checkoutRequest = checkoutRequest;
function checkoutResume(order_number) {
  return __awaiter(this, void 0, void 0, function () {
    var endpoints, resp, _a, _b;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          endpoints = {
            v1: Config_1.get().apiHost + "/checkout/resume?token=" + Config_1.get().UserOutlet.getValue().token + "&order_number=" + order_number,
            v2: Config_1.get().apiHost + "/payment/resume?token=" + Config_1.get().UserOutlet.getValue().token + "&order_number=" + order_number
          };
          if (!(Config_1.get().fastelVersion.indexOf('v2') > -1)) return [3 /*break*/, 3];
          return [4 /*yield*/, fetch(endpoints[Config_1.get().fastelVersion])];
        case 1:
          resp = _c.sent();
          _b = (_a = document).write;
          return [4 /*yield*/, resp.text()];
        case 2:
          _b.apply(_a, [_c.sent()]);
          return [2 /*return*/];
        case 3:
          ApiUtil_1.redirect(endpoints[Config_1.get().fastelVersion]);
          return [2 /*return*/];
      }
    });
  });
}

exports.checkoutResume = checkoutResume;
function returnRequest(order_id) {
  return __awaiter(this, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/return/request?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'POST',
            data: {
              order: order_id
            }
          })];
        case 1:
          resp = _a.sent();
          if (resp === null || resp === void 0 ? void 0 : resp._id.$oid) {
            resp.id = resp._id.$oid;
            delete resp._id;
          }
          return [2 /*return*/, resp];
      }
    });
  });
}
exports.returnRequest = returnRequest;
function returnConfirm(id, status) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/return/confirm?token=" + Config_1.get().UserOutlet.getValue().token, {
        method: 'POST',
        data: {
          id: id,
          status: status
        }
      })];
    });
  });
}
exports.returnConfirm = returnConfirm;
function getZip3() {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, taiwan_1.zip3];
    });
  });
}
exports.getZip3 = getZip3;
function onSelectCVS(cvs_subtype) {
  return __awaiter(this, void 0, void 0, function () {
    var endpoints, url;
    return __generator(this, function (_a) {
      endpoints = {
        v1: Config_1.get().apiHost + "/cart/cvs-map?client_id=" + Config_1.get().clientId + "&token=" + Config_1.get().UserOutlet.getValue().token,
        v2: Config_1.get().apiHost + "/logistics/map/request?token=" + Config_1.get().UserOutlet.getValue().token + "&cvs_subtype=" + cvs_subtype + "&url=" + window.location.href
      };
      url = endpoints[Config_1.get().fastelVersion];
      ApiUtil_1.redirect(url);
      return [2 /*return*/];
    });
  });
}

exports.onSelectCVS = onSelectCVS;
function updateOfflineTx(_a) {
  var id = _a.id,
    owner = _a.owner,
    offline_tx = _a.offline_tx,
    offline_username = _a.offline_username,
    offline_date = _a.offline_date;
  return __awaiter(this, void 0, void 0, function () {
    var token;
    return __generator(this, function (_b) {
      token = owner.indexOf('tmp_') === 0 ? owner : Config_1.get().UserOutlet.getValue().token;
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/order/offline/tx?token=" + token, {
        method: 'POST',
        data: {
          id: id,
          offline_tx: offline_tx,
          offline_username: offline_username,
          offline_date: offline_date
        }
      })];
    });
  });
}
exports.updateOfflineTx = updateOfflineTx;
var INVOICE_CATEGORY = {
  b2c: 'B2C',
  b2b: 'B2B'
};
exports.INVOICE_CATEGORY = INVOICE_CATEGORY;
var INVOICE_CATEGORY_DISPLAY = (_a = {}, _a[INVOICE_CATEGORY.b2c] = {
  label: '二聯式發票',
  value: INVOICE_CATEGORY.b2c
}, _a[INVOICE_CATEGORY.b2b] = {
  label: '三聯式發票 ( 開立統一編號 ）',
  value: INVOICE_CATEGORY.b2b
}, _a);
exports.INVOICE_CATEGORY_DISPLAY = INVOICE_CATEGORY_DISPLAY;
var INVOICE_DONATION = {
  f: '0',
  t: '1'
};
exports.INVOICE_DONATION = INVOICE_DONATION;
var INVOICE_DONATION_DISPLAY = (_b = {}, _b[INVOICE_DONATION.t] = {
  label: '捐贈',
  value: INVOICE_DONATION.t
}, _b[INVOICE_DONATION.f] = {
  label: '不捐贈',
  value: INVOICE_DONATION.f
}, _b);
exports.INVOICE_DONATION_DISPLAY = INVOICE_DONATION_DISPLAY;
var INVOICE_CARRIER_TYPE = {
  none: '0',
  ecpay: '1',
  cdc: '2',
  mobile: '3'
};
exports.INVOICE_CARRIER_TYPE = INVOICE_CARRIER_TYPE;
var INVOICE_CARRIER_TYPE_DISPLAY = (_c = {}, _c[INVOICE_CARRIER_TYPE.none] = {
  label: '無載具',
  value: INVOICE_CARRIER_TYPE.none
}, _c[INVOICE_CARRIER_TYPE.ecpay] = {
  label: '電子發票',
  value: INVOICE_CARRIER_TYPE.ecpay
}, _c[INVOICE_CARRIER_TYPE.cdc] = {
  label: '自然人憑證',
  value: INVOICE_CARRIER_TYPE.cdc
}, _c[INVOICE_CARRIER_TYPE.mobile] = {
  label: '手機條碼載具',
  value: INVOICE_CARRIER_TYPE.mobile
}, _c);
exports.INVOICE_CARRIER_TYPE_DISPLAY = INVOICE_CARRIER_TYPE_DISPLAY;
var PAYMENT_SUBTYPE = {
  default: 'default',
  credit: 'credit',
  cod: 'cod',
  atm: 'atm',
  offline: 'offline',
  linepay: 'linepay'
};
exports.PAYMENT_SUBTYPE = PAYMENT_SUBTYPE;
var PAYMENT_SUBTYPE_DISPLAY = (_d = {}, _d[PAYMENT_SUBTYPE.default] = {
  label: '預設付款方式',
  value: PAYMENT_SUBTYPE.default
}, _d[PAYMENT_SUBTYPE.credit] = {
  label: '信用卡付款',
  value: PAYMENT_SUBTYPE.credit
}, _d[PAYMENT_SUBTYPE.cod] = {
  label: '貨到付款',
  value: PAYMENT_SUBTYPE.cod
}, _d[PAYMENT_SUBTYPE.atm] = {
  label: 'ATM虛擬帳號',
  value: PAYMENT_SUBTYPE.atm
}, _d[PAYMENT_SUBTYPE.offline] = {
  label: 'ATM轉帳匯款',
  value: PAYMENT_SUBTYPE.offline
}, _d[PAYMENT_SUBTYPE.linepay] = {
  label: 'LINE Pay',
  value: PAYMENT_SUBTYPE.linepay
}, _d);
exports.PAYMENT_SUBTYPE_DISPLAY = PAYMENT_SUBTYPE_DISPLAY;
var LOGISTICS_TYPE = {
  cvs: 'CVS',
  home: 'HOME',
  custom: 'CUSTOM',
  self_pick: 'SELF_PICK',
  oversea: 'OVERSEA'
};
exports.LOGISTICS_TYPE = LOGISTICS_TYPE;
var LOGISTICS_TYPE_DISPLAY = (_e = {}, _e[LOGISTICS_TYPE.cvs] = {
  label: '超商取貨',
  value: LOGISTICS_TYPE.cvs
}, _e[LOGISTICS_TYPE.home] = {
  label: '宅配到府',
  value: LOGISTICS_TYPE.home
}, _e[LOGISTICS_TYPE.self_pick] = {
  label: '自取',
  value: LOGISTICS_TYPE.self_pick
}, _e[LOGISTICS_TYPE.custom] = {
  label: '客製訂單',
  value: LOGISTICS_TYPE.custom
}, _e[LOGISTICS_TYPE.oversea] = {
  label: '海外',
  value: LOGISTICS_TYPE.oversea
}, _e);
exports.LOGISTICS_TYPE_DISPLAY = LOGISTICS_TYPE_DISPLAY;
var LOGISTICS_STATUS = {
  pending: 'pending',
  center_delivered: 'center_delivered',
  in_delivery: 'in_delivery',
  store_delivered: 'store_delivered',
  delivered: 'delivered',
  exception: 'exception',
  error: 'error'
};
exports.LOGISTICS_STATUS = LOGISTICS_STATUS;
var LOGISTICS_STATUS_DISPLAY = (_f = {}, _f[LOGISTICS_STATUS.pending] = {
  label: '備貨中',
  value: LOGISTICS_STATUS.pending
}, _f[LOGISTICS_STATUS.center_delivered] = {
  label: '已出貨',
  value: LOGISTICS_STATUS.center_delivered
}, _f[LOGISTICS_STATUS.in_delivery] = {
  label: '運送中',
  value: LOGISTICS_STATUS.in_delivery
}, _f[LOGISTICS_STATUS.store_delivered] = {
  label: '到店尚未取貨',
  value: LOGISTICS_STATUS.store_delivered
}, _f[LOGISTICS_STATUS.delivered] = {
  label: '已送達',
  value: LOGISTICS_STATUS.delivered
}, _f[LOGISTICS_STATUS.error] = {
  label: '發生錯誤',
  value: LOGISTICS_STATUS.error
}, _f[LOGISTICS_STATUS.exception] = {
  label: '第三方自定義狀態',
  value: LOGISTICS_STATUS.exception
}, _f);
exports.LOGISTICS_STATUS_DISPLAY = LOGISTICS_STATUS_DISPLAY;
var LOGISTICS_SUBTYPE = {
  famic2c: 'FAMIC2C',
  unimartc2c: 'UNIMARTC2C',
  hilifec2c: 'HILIFEC2C',
  TCAT: 'TCAT',
  ECAN: 'ECAN',
  SF: 'SF',
  SF_OVERSEA_HK: 'HK',
  SF_OVERSEA_MO: 'MO',
  SF_OVERSEA_CN: 'CN',
  fami: 'FAMI',
  unimart: 'UNIMART',
  hilife: 'HILIFE' // B2C
};

exports.LOGISTICS_SUBTYPE = LOGISTICS_SUBTYPE;
var LOGISTICS_SUBTYPE_DISPLAY = (_g = {}, _g[LOGISTICS_SUBTYPE.famic2c] = {
  label: '全家便利超商',
  value: LOGISTICS_SUBTYPE.famic2c
}, _g[LOGISTICS_SUBTYPE.unimartc2c] = {
  label: '7-ELEVEN便利超商',
  value: LOGISTICS_SUBTYPE.unimartc2c
}, _g[LOGISTICS_SUBTYPE.hilifec2c] = {
  label: '萊爾富便利超商',
  value: LOGISTICS_SUBTYPE.hilifec2c
}, _g[LOGISTICS_SUBTYPE.TCAT] = {
  label: '黑貓宅急便',
  value: LOGISTICS_SUBTYPE.TCAT
}, _g[LOGISTICS_SUBTYPE.ECAN] = {
  label: '宅配通',
  value: LOGISTICS_SUBTYPE.ECAN
}, _g[LOGISTICS_SUBTYPE.SF] = {
  label: '順豐速運',
  value: LOGISTICS_SUBTYPE.SF
}, _g[LOGISTICS_SUBTYPE.SF_OVERSEA_HK] = {
  label: '順豐速運-香港',
  value: LOGISTICS_SUBTYPE.SF_OVERSEA_HK
}, _g[LOGISTICS_SUBTYPE.SF_OVERSEA_MO] = {
  label: '順豐速運-澳門',
  value: LOGISTICS_SUBTYPE.SF_OVERSEA_MO
}, _g[LOGISTICS_SUBTYPE.SF_OVERSEA_CN] = {
  label: '順豐速運-大陸',
  value: LOGISTICS_SUBTYPE.SF_OVERSEA_CN
}, _g[LOGISTICS_SUBTYPE.fami] = {
  label: '全家便利超商',
  value: LOGISTICS_SUBTYPE.fami
}, _g[LOGISTICS_SUBTYPE.unimart] = {
  label: '7-ELEVEN便利超商',
  value: LOGISTICS_SUBTYPE.unimart
}, _g[LOGISTICS_SUBTYPE.hilife] = {
  label: '萊爾富便利超商',
  value: LOGISTICS_SUBTYPE.hilife
}, _g);
exports.LOGISTICS_SUBTYPE_DISPLAY = LOGISTICS_SUBTYPE_DISPLAY;
var LOGISTICS_ORDER_ID_TRACKING_URL = (_h = {}, _h[LOGISTICS_SUBTYPE.famic2c] = 'https://ecfme.famiport.com.tw/FPWeb_query_shipstatus_M/FPWeb_query_shipstatus_M.aspx', _h[LOGISTICS_SUBTYPE.unimartc2c] = 'https://eservice.7-11.com.tw/e-tracking/search.aspx', _h[LOGISTICS_SUBTYPE.hilifec2c] = 'https://www.hilife.com.tw/serviceInfo_search.aspx', _h[LOGISTICS_SUBTYPE.ECAN] = 'http://query2.e-can.com.tw/ECAN_APP/search.shtm', _h[LOGISTICS_SUBTYPE.TCAT] = 'https://www.t-cat.com.tw/inquire/trace.aspx', _h[LOGISTICS_SUBTYPE.SF] = '', _h);
exports.LOGISTICS_ORDER_ID_TRACKING_URL = LOGISTICS_ORDER_ID_TRACKING_URL;
var CVS_ICON = (_j = {}, _j[LOGISTICS_SUBTYPE.famic2c] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/fimi_logo-1631158279', _j[LOGISTICS_SUBTYPE.unimartc2c] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/unimart_logo-1631158301', _j[LOGISTICS_SUBTYPE.hilifec2c] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/hilife_logo-1631158173', _j[LOGISTICS_SUBTYPE.fami] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/fimi_logo-1631158279', _j[LOGISTICS_SUBTYPE.unimart] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/unimart_logo-1631158301', _j[LOGISTICS_SUBTYPE.hilife] = 'https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/hilife_logo-1631158173', _j);
exports.CVS_ICON = CVS_ICON;
var PAYMENT_STATUS = {
  pending: 'pending',
  waiting: 'waiting',
  success: 'success',
  failure: 'failure',
  returned: 'returned',
  code_generated: 'code_generated'
};
exports.PAYMENT_STATUS = PAYMENT_STATUS;
var PAYMENT_STATUS_DISPLAY = (_k = {}, _k[PAYMENT_STATUS.pending] = {
  value: PAYMENT_STATUS.pending,
  label: '尚未付款'
}, _k[PAYMENT_STATUS.waiting] = {
  value: PAYMENT_STATUS.waiting,
  label: '款項確認中'
}, _k[PAYMENT_STATUS.success] = {
  value: PAYMENT_STATUS.success,
  label: '付款成功'
}, _k[PAYMENT_STATUS.failure] = {
  value: PAYMENT_STATUS.failure,
  label: '付款失敗'
}, _k[PAYMENT_STATUS.returned] = {
  value: PAYMENT_STATUS.returned,
  label: '已退款'
}, _k[PAYMENT_STATUS.code_generated] = {
  value: PAYMENT_STATUS.code_generated,
  label: '已取號'
}, _k);
exports.PAYMENT_STATUS_DISPLAY = PAYMENT_STATUS_DISPLAY;
var ORDER_STATUS = {
  waiting: 'waiting',
  processing: 'processing',
  done: 'done',
  canceled: 'canceled',
  return_applied: 'return_applied',
  return_completed: 'return_completed'
};
exports.ORDER_STATUS = ORDER_STATUS;
var ORDER_STATUS_DISPLAY = (_l = {}, _l[ORDER_STATUS.waiting] = {
  value: ORDER_STATUS.waiting,
  label: '待處理'
}, _l[ORDER_STATUS.processing] = {
  value: ORDER_STATUS.processing,
  label: '處理中'
}, _l[ORDER_STATUS.done] = {
  value: ORDER_STATUS.done,
  label: '已完成'
}, _l[ORDER_STATUS.canceled] = {
  value: ORDER_STATUS.canceled,
  label: '已取消'
}, _l[ORDER_STATUS.return_applied] = {
  value: ORDER_STATUS.return_applied,
  label: '退貨審核通過'
}, _l[ORDER_STATUS.return_completed] = {
  value: ORDER_STATUS.return_completed,
  label: '已退款'
}, _l);
exports.ORDER_STATUS_DISPLAY = ORDER_STATUS_DISPLAY;
var ORDER_UI_STATUS;
(function (ORDER_UI_STATUS) {
  ORDER_UI_STATUS["unpaid"] = "unpaid";
  ORDER_UI_STATUS["pending"] = "pending";
  ORDER_UI_STATUS["processing"] = "processing";
  ORDER_UI_STATUS["shipped"] = "shipped";
  ORDER_UI_STATUS["canceled"] = "canceled";
  ORDER_UI_STATUS["return_applied"] = "return_applied";
  ORDER_UI_STATUS["return_completed"] = "return_completed";
  ORDER_UI_STATUS["unknown"] = "unknown";
})(ORDER_UI_STATUS || (ORDER_UI_STATUS = {}));
exports.ORDER_UI_STATUS = ORDER_UI_STATUS;
var ORDER_UI_STATUS_DISPLAY;
(function (ORDER_UI_STATUS_DISPLAY) {
  ORDER_UI_STATUS_DISPLAY["unpaid"] = "\u672A\u4ED8\u6B3E";
  ORDER_UI_STATUS_DISPLAY["pending"] = "\u5F85\u8655\u7406";
  ORDER_UI_STATUS_DISPLAY["processing"] = "\u8655\u7406\u4E2D";
  ORDER_UI_STATUS_DISPLAY["shipped"] = "\u5DF2\u51FA\u8CA8";
  ORDER_UI_STATUS_DISPLAY["canceled"] = "\u5DF2\u53D6\u6D88";
  ORDER_UI_STATUS_DISPLAY["return_applied"] = "\u9000\u8CA8\u5BE9\u6838\u901A\u904E";
  ORDER_UI_STATUS_DISPLAY["return_completed"] = "\u5DF2\u9000\u6B3E";
  ORDER_UI_STATUS_DISPLAY["unknown"] = "\u672A\u77E5\u72C0\u614B";
})(ORDER_UI_STATUS_DISPLAY || (ORDER_UI_STATUS_DISPLAY = {}));
exports.ORDER_UI_STATUS_DISPLAY = ORDER_UI_STATUS_DISPLAY;
var RETURN_STATUS = {
  pending: 'pending',
  return_rejected: 'return_rejected',
  return_applied: 'return_applied',
  return_completed: 'return_completed'
};
exports.RETURN_STATUS = RETURN_STATUS;
var RETURN_STATUS_DISPLAY = (_m = {}, _m[RETURN_STATUS.pending] = {
  value: RETURN_STATUS.pending,
  label: '等待審核'
}, _m[RETURN_STATUS.return_rejected] = {
  value: RETURN_STATUS.return_rejected,
  label: '審核不通過'
}, _m[RETURN_STATUS.return_applied] = {
  value: RETURN_STATUS.return_applied,
  label: '審核通過'
}, _m[RETURN_STATUS.return_completed] = {
  value: RETURN_STATUS.return_completed,
  label: '已退款'
}, _m);
exports.RETURN_STATUS_DISPLAY = RETURN_STATUS_DISPLAY;